//import Base64 from 'crypto-js/enc-base64';
//import sha256 from 'crypto-js/sha256';
import {ENTRYPOINT} from "../config/entrypoint";


export default {
  buildLoginUrl() {
    return new URL(ENTRYPOINT + '/oidc-login');
  },
  handleCodeRedirect(query) {
    const tokenUrl = this.buildLoginUrl();
    for (const k in query) {
      if (query.hasOwnProperty(k)) {
        tokenUrl.searchParams.append(k, query[k]);
      }
    }
    return tokenUrl;
  }
}
